import { Injectable } from '@angular/core';
import { ClienteAnaliseMercadoFormModalData } from './cliente-analise-mercado-form-modal-data';
import { ClienteAnaliseMercadoPerspectiva } from '../../perspectivas/cliente-analise-mercado-perspectiva';

@Injectable()
export class ClienteAnaliseMercadoFormModal {
   data: ClienteAnaliseMercadoFormModalData;

    /** Se o modal está aberto */
    isOpen = false;

    open(idCliente: number, ano: number, perspectiva: ClienteAnaliseMercadoPerspectiva) {
        this.data = new ClienteAnaliseMercadoFormModalData(idCliente, ano, perspectiva);
        this.isOpen = true;
    }

    close() {
        this.data = null;
        this.isOpen = false;
    }
}
